import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import CustomModal from "../../components/ui/CustomModal";
import TableFilter from "./TableFilter";

const StylistPage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const { queryParams } = useQueryParams();
    const pageNo = queryParams.get("page") || 0;
    const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
    const sortOrder = queryParams.get("sortOrder") || "DESC";
    const location = useLocation();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                keyword: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/aistylist/v2/stylists?type=VIRTUAL&page=${pageNo}&size=${pageSize}&sortBy=createdAt&direction=${sortOrder}&${query}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("User");
    }, [location.search]);

    const handleStatusChanges = async (id) => {
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/agent/${id}/status/0`, {
                method: "PUT",
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully deleted a agent, Thank You!",
                });
                callListApi();
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully deleted a agent!",
                    status: true,
                    archive: false,
                });
            }
            else {
                addToastMessage({
                    status: false,
                    message: response?.responseDescription ||
                        `Something went wrong while deleting agent. Please try again.`,
                });
            }
        } catch (error) {
            addToastMessage({
                status: false,
                message: `Something went wrong while deleting agent. Please try again.`,
            });
        }
    };

    return (
        <>
            <PageMeta
                title={`Stylist - ${DEFAULT_PAGE_TITLE}`}
                description={`Stylist - ${DEFAULT_PAGE_DESCRIPTION}`}
            />
            <div className="flex justify-between items-center mb-6">
                <TableFilter />
            </div>
            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="relative overflow-x-auto sm:rounded-lg">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3"> Name</th>
                                    <th scope="col" className="px-6 py-3"> Persona</th>
                                    <th scope="col" className="px-6 py-3"> Status</th>
                                    <th scope="col" className="px-6 py-3"> Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.data?.length > 0 ? data?.data?.map((user, index) => (
                                    <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <div className="flex items-center gap-2">
                                                {user.photoSignedUrl ? (
                                                    <img
                                                        src={user.photoSignedUrl}
                                                        alt={user.displayName || "Stylist"}
                                                        className="w-8 h-8 rounded-full object-fill"
                                                    />
                                                ) : (
                                                    <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center text-sm font-semibold text-gray-700">
                                                        {user.displayName ? user.displayName.charAt(0).toUpperCase() : "-"}
                                                    </div>
                                                )}
                                                <span>{user.displayName || "-"}</span>
                                            </div>
                                        </td>


                                        {/* <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">{user.stylistName || "-"}</td> */}
                                        <td className="px-6 py-4">{user.persona || "-"}</td>
                                        <td className="px-6 py-4">
                                            <CustomModal
                                                selector={
                                                    <label className="inline-flex items-center cursor-pointer">
                                                        {/* Hidden checkbox for semantics */}
                                                        <input
                                                            type="checkbox"
                                                            checked={user?.isActive}
                                                            readOnly
                                                            className="sr-only"
                                                        />
                                                        <div
                                                            className={`w-32 h-8 flex items-center justify-center rounded-full relative transition-colors duration-300 ${user?.isActive ? "bg-green-500" : "bg-gray-400"
                                                                }`}
                                                        >
                                                            <div
                                                                className={`absolute top-1 w-6 h-6 rounded-full bg-white shadow transition-all duration-300 ${user?.active ? "right-1" : "left-1"
                                                                    }`}
                                                            />
                                                            <span
                                                                className={`absolute w-full text-center text-xs font-medium transition-opacity duration-300 ${user?.isActive ? "opacity-100 text-white" : "opacity-0"
                                                                    }`}
                                                            >
                                                                Active
                                                            </span>
                                                            <span
                                                                className={`absolute w-full text-center text-xs font-medium transition-opacity duration-300 ${!user?.isActive ? "opacity-100 text-white" : "opacity-0"
                                                                    }`}
                                                            >
                                                                Inactive
                                                            </span>
                                                        </div>
                                                    </label>
                                                }
                                                content={
                                                    <ConfirmationModal
                                                        onConfirm={async () => {
                                                            await handleStatusChanges(user?.departmentId, !user?.isActive);
                                                            return true; // closes modal
                                                        }}
                                                        message={`Are you sure you want to ${user?.isActive ? "deactivate" : "activate"
                                                            } this user?`}
                                                    />
                                                }
                                            />
                                        </td>
                                        <td className="px-6 py-4 flex gap-5">
                                            <NavLink
                                                to={`/stylists-details/${user?.id}`}
                                                state={{ user: user }}
                                            >
                                                <button
                                                    type="button"
                                                    className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:bg-yellow-700 transition"
                                                >
                                                    View
                                                </button>
                                            </NavLink>
                                        </td>
                                    </tr>
                                )) : (
                                        <tr>
                                            <td colSpan="9" className="px-4 py-4 text-center text-gray-500 dark:text-gray-400">
                                                No data found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                        </table>
                    </div>
                </div>
            )}
            <div className='flex justify-center items-center'>
                <Pagination
                    pageParam="page"
                    currentPage={data?.pageNumber + 1}
                    totalElements={data?.totalElements}
                />
            </div>
        </>
    );
};
export default StylistPage;